export default __webpack_public_path__ + "static/media/comment.364369da.png";